import { LicenseName } from "@/data/license.data";
import { getUserUniqueTextToSpeechTextLengthLimit } from "@/actions/db/user-unique-dataset-limits";
import { ServiceUsingTextLimiter } from "@/services/license/license-limiters/base-limiters/service-using-text-limiter";

export const trialTtsMaxLength = 500;
export const starterTtsMaxLength = 3000;
export const creatorTtsMaxLength = 3000;
export const studioTtsMaxLength = 3000;

export class TextToSpeechTextLimiter extends ServiceUsingTextLimiter {
  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return trialTtsMaxLength;
      case "Basic":
        return trialTtsMaxLength;
      case "Starter":
        return starterTtsMaxLength;
      case "Creator":
        return creatorTtsMaxLength;
      case "Studio":
        return studioTtsMaxLength;
      case "Premium":
        return studioTtsMaxLength;
      case "Ultimate":
        return studioTtsMaxLength;
    }
  }

  getUniqueLimit(userId: string): Promise<number | null> {
    return getUserUniqueTextToSpeechTextLengthLimit(userId);
  }
}
